export default __webpack_public_path__ + "static/media/(65).93d86f1e.jpg";